var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateMeasure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.511,
    height: 15.182,
    viewBox: "0 0 13.511 15.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1947",
    "data-name": "Group 1947",
    transform: "translate(-939 -592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Request_Information",
    "data-name": "Request Information",
    transform: "translate(939 592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M11.346,5.868a1.579,1.579,0,0,0-1.091-.537,1.662,1.662,0,0,0-.309.009V3.5a.376.376,0,0,0-.109-.268L6.718.119l0,0A.377.377,0,0,0,6.443,0c-.012,0-.024.008-.036.009S6.382.014,6.37.014H-.184A1.5,1.5,0,0,0-1.7,1.509V13.64A1.528,1.528,0,0,0-.184,15.182H8.424A1.536,1.536,0,0,0,9.946,13.64V9.366L11.28,8.192a1.586,1.586,0,0,0,.146-2.23ZM9.384,8.855a.378.378,0,0,0-.114.1l-.863.761L6.28,11.579l-1.469.084.3-1.415L8.668,7.12,9.837,8.456ZM6.836,1.293,8.663,3.124H6.836ZM9.187,13.64a.777.777,0,0,1-.763.783H-.184a.769.769,0,0,1-.753-.783V1.527A.744.744,0,0,1-.2.773H6.078V3.508a.363.363,0,0,0,.352.374H9.187V5.654a.446.446,0,0,0-.081.068l-.6.525a.377.377,0,0,0-.118.1L4.515,9.761a.379.379,0,0,0-.121.206l-.427,2.023a.379.379,0,0,0,.371.458h.022l2.094-.12a.38.38,0,0,0,.228-.093l2.176-1.908.329-.293Zm1.594-6.017-.375.331L9.238,6.62l.373-.327a.825.825,0,0,1,1.164.075h0l.082.093A.826.826,0,0,1,10.782,7.623Zm0,0",
    transform: "translate(1.695 0)",
    fill: "#535765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M70.731,151.09h3.036a.379.379,0,0,0,0-.758H70.731a.379.379,0,0,0,0,.758Zm0,0",
    transform: "translate(-68.164 -145.767)",
    fill: "#535765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M75.905,231.883a.379.379,0,0,0-.379-.379h-4.8a.379.379,0,1,0,0,.758h4.8A.379.379,0,0,0,75.905,231.883Zm0,0",
    transform: "translate(-68.164 -224.475)",
    fill: "#535765"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateMeasure);
export default __webpack_public_path__ + "static/media/UpdateMeasure.5e370ef4.svg";
export { ForwardRef as ReactComponent };